import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BasicRoutingModule } from './basic-routing.module';
import { FacesheetComponent, TruncatePipe } from './facesheet/facesheet.component';
import { InfoComponent } from './info/info.component';
import { BasicInfoComponent } from './components/basic-info/basic-info.component';
import { UserSelectModule } from './components/user-select/user-select.component';
import { SharedModule } from '@app/shared/shared.module';
import { ComponentsSharedModule } from '@app/components/components-shared.module';
import { FacesheetEditComponent } from './facesheet/facesheet-edit/facesheet-edit.component';
import { FacesheetCreateComponent } from './facesheet/facesheet-create/facesheet-create.component';
import { RecordModule } from '@app/record/record.module';

@NgModule({
  declarations: [
    FacesheetComponent,
    InfoComponent,
    BasicInfoComponent,
    FacesheetEditComponent,
    FacesheetCreateComponent,
    TruncatePipe
  ],
  imports: [
    UserSelectModule,
    CommonModule,
    BasicRoutingModule,
    SharedModule,
    ComponentsSharedModule,
    RecordModule,
  ],
})
export class BasicModule {}
